import React from 'react';
import {
  Button,
  Dialog,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import AppState from '../../../state';
import { browserHistory } from 'react-router';
import { Utils } from '../../../services';
import ReactTable from 'react-table';

const MESES = [
  { value: 1,  label: 'Janeiro' },
  { value: 2,  label: 'Fevereiro' },
  { value: 3,  label: 'Março' },
  { value: 4,  label: 'Abril' },
  { value: 5,  label: 'Maio' },
  { value: 6,  label: 'Junho' },
  { value: 7,  label: 'Julho' },
  { value: 8,  label: 'Agosto' },
  { value: 9,  label: 'Setembro' },
  { value: 10, label: 'Outubro' },
  { value: 11, label: 'Novembro' },
  { value: 12, label: 'Dezembro' },
];

const currentYear = new Date().getFullYear();
const ANOS = Array.from({ length: currentYear - 1999 }, (_, i) => 2000 + i).concat(
  currentYear + 1,
  currentYear + 2
);

class ImporteIndices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      taxasMensais: [],
      mesSelecionado: '',
      anoSelecionado: currentYear,
      taxaMensal: '',
    };
  }

  componentDidMount() {
    this.getTaxasMensais();
  }

  handleTaxaKeyDown = (e) => {
    const controlKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (controlKeys.includes(e.key) || e.ctrlKey || e.metaKey) return;
    // Aceita apenas dígitos, ponto decimal e sinal de menos
    if (!/^[\d.\-]$/.test(e.key)) {
      e.preventDefault();
    }
  };

  handleTaxaChange = (e) => {
    const val = e.target.value;
    if (val === '' || val === '-') {
      this.setState({ taxaMensal: val });
      return;
    }
    // Rejeita formatos inválidos: "10-", "1.2.3", espaços, letras residuais
    if (!/^-?\d*\.?\d*$/.test(val)) return;
    const num = parseFloat(val);
    if (!isNaN(num) && Math.abs(num) <= 100) {
      this.setState({ taxaMensal: val });
    }
  };

  closeDialog = () => {
    this.props.close();
  };

  getTaxasMensais = () => {
    AppState.isLoading = true;
    fetch(`${AppState.serverAddr}/relatorios/GetTaxaMensal.php`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: AppState.token,
      },
    })
      .then((response) => {
        if (response.status === 401) {
          AppState.isLoading = false;
          browserHistory.push(`${process.env.PUBLIC_URL}/logout`);
          return;
        }
        return response.json();
      })
      .then((response) => {
        AppState.isLoading = false;
        this.setState({ taxasMensais: response.request || [] });
      })
      .catch(() => {
        AppState.isLoading = false;
      });
  };

  salvarTaxa = () => {
    const { mesSelecionado, anoSelecionado, taxaMensal, taxasMensais } = this.state;

    if (!mesSelecionado || !anoSelecionado) {
      alert('Selecione o mês e o ano de referência.');
      return;
    }

    const taxaNum = parseFloat(taxaMensal);
    if (taxaMensal === '' || isNaN(taxaNum)) {
      alert('Informe uma taxa mensal válida.');
      return;
    }
    if (taxaNum < -100 || taxaNum > 100) {
      alert('A taxa deve estar entre -100% e 100%.');
      return;
    }
    if (taxaNum < 0) {
      if (!window.confirm(`A taxa informada é negativa (${taxaNum}%). Confirma o cadastro?`)) {
        return;
      }
    }

    const mesStr = String(mesSelecionado).padStart(2, '0');
    const mesRefData = `${anoSelecionado}-${mesStr}-01`;

    const existente = taxasMensais.find((t) => t.mes_referencia === mesRefData);
    if (existente) {
      const valorExistente = (parseFloat(existente.taxa_mensal) * 100).toFixed(4);
      const mesFormatado = Utils.dateToPT(existente.mes_referencia).substring(3);
      if (
        !window.confirm(
          `Já existe a taxa ${valorExistente}% para ${mesFormatado}. Deseja atualizar este valor?`
        )
      ) {
        return;
      }
    }

    AppState.isLoading = true;
    fetch(`${AppState.serverAddr}/relatorios/SalvaTaxaMensal.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: AppState.token,
      },
      body: JSON.stringify({ mes_referencia: mesRefData, taxa_mensal: taxaNum / 100 }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            const error = new Error(response.status);
            error.response = json;
            throw error;
          });
        }
        return response.json();
      })
      .then(() => {
        AppState.isLoading = false;
        this.setState({ mesSelecionado: '', anoSelecionado: '', taxaMensal: '' });
        this.getTaxasMensais();
      })
      .catch((error) => {
        AppState.isLoading = false;
        if (error.toString().split(' ')[1] === '401') {
          browserHistory.push(`${process.env.PUBLIC_URL}/logout`);
        } else {
          alert('Erro ao salvar taxa. Tente novamente.');
        }
      });
  };

  render() {
    const { taxasMensais, mesSelecionado, anoSelecionado, taxaMensal } = this.state;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.closeDialog}
        disableBackdropClick={true}
        fullScreen
      >
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
          {/* Cabeçalho fixo */}
          <div style={{ padding: '24px 24px 16px', background: '#fff', flexShrink: 0 }}>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              style={{ flexWrap: 'nowrap' }}
            >
              <Typography variant="h4">Gerenciamento de Taxas Mensais</Typography>
              <Icon onClick={() => this.closeDialog()} style={{ cursor: 'pointer' }}>close</Icon>
            </Grid>

            <Grid container alignItems="flex-end" spacing={2} style={{ marginTop: '32px' }}>
                <Grid item>
                  <FormControl style={{ minWidth: 140 }}>
                    <InputLabel>Mês</InputLabel>
                    <Select
                      value={mesSelecionado}
                      onChange={(e) => this.setState({ mesSelecionado: e.target.value })}
                    >
                      {MESES.map((m) => (
                        <MenuItem key={m.value} value={m.value}>
                          {m.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item>
                  <FormControl style={{ minWidth: 100 }}>
                    <InputLabel>Ano</InputLabel>
                    <Select
                      value={anoSelecionado}
                      onChange={(e) => this.setState({ anoSelecionado: e.target.value })}
                    >
                      {ANOS.map((a) => (
                        <MenuItem key={a} value={a}>
                          {a}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item>
                  <TextField
                    label="Taxa mensal (%)"
                    type="text"
                    value={taxaMensal}
                    onKeyDown={this.handleTaxaKeyDown}
                    onChange={this.handleTaxaChange}
                    inputProps={{ inputMode: 'decimal' }}
                    style={{ minWidth: 140 }}
                  />
                </Grid>
                <Grid item>
                  <Button variant="contained" color="primary" onClick={this.salvarTaxa}>
                    Salvar
                  </Button>
                </Grid>
              </Grid>
          </div>

          {/* Área de scroll da tabela */}
          <div style={{ flex: 1, overflowY: 'auto', padding: '0 24px 24px' }}>
            <ReactTable
                filterable
                fullWidth
                className="-striped -highlight"
                style={{ marginTop: '16px', width: '100%' }}
                data={taxasMensais}
                defaultPageSize={25}
                showPagination={true}
                showPageSizeOptions={true}
                pageSizeOptions={[10, 25, 50, 100]}
                defaultFilterMethod={(filter, row) =>
                  Utils.tableFilterMatch(row[filter.id], filter.value)
                }
                columns={[
                  {
                    columns: [
                      {
                        Header: 'Mês de referência',
                        accessor: 'mes_referencia',
                        Cell: (row) => (
                          <div style={{ textAlign: 'center' }}>
                            {Utils.dateToPT(row.value).substring(3)}
                          </div>
                        ),
                      },
                      {
                        Header: 'Taxa mensal (%)',
                        accessor: 'taxa_mensal',
                        filterable: false,
                        Cell: (row) => (
                          <div style={{ textAlign: 'center' }}>
                            {(parseFloat(row.value) * 100).toFixed(4)}%
                          </div>
                        ),
                      },
                    ],
                  },
                ]}
              />
          </div>
        </div>
      </Dialog>
    );
  }
}

ImporteIndices.propTypes = {};

export default ImporteIndices;
